import Future from 'fluture';
import cookies from 'browser-cookies';
import * as r from 'ramda';

function formatEnabledFlag(enabled) {
  // In tealium it is backwards for some reason
  // 0 = true
  // 1 = false
  // I think they were drunk
  return r.ifElse(
    r.equals(true),
    r.always('0'),
    r.always('1'),
  )(enabled);
}

export default function createOptIn(

) {
  return function OptIn(
    settings,
    expires,
  ) {
    const cookieValue = r.pipe(
      r.values,
      r.map((category) => `${category.id}:${formatEnabledFlag(category.enabled)}`),
      r.prepend('0:0'),
      r.join('|'),
    )(settings);

    cookies.set(
      'OPTOUTMULTI',
      cookieValue,
      {
        secure: false,
        expires,
        domain: window.utag.cfg.domain,
      },
    );

    return Future.of(true);
  }
}



// WEBPACK FOOTER //
// ./src/infrastructure/optIn.js